module.exports = __webpack_public_path__ + "static/media/bottom-sc.6c3445b3.png";